/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantDetailsSortCriteria {
    getFixupPrototypeFunction() { return TenantDetailsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<TenantDetailsSortCriteria>): TenantDetailsSortCriteria {
        let obj = Object.assign(new TenantDetailsSortCriteria(), model);
        TenantDetailsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantDetailsSortCriteria>): TenantDetailsSortCriteria {
        if (!model) return null;
        return TenantDetailsSortCriteria.newInstance(<TenantDetailsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantDetailsSortCriteria) {
        if (!obj) return;

        models.TenantDetailsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantDetailsSortCriteria): boolean {
        Object.setPrototypeOf(obj, TenantDetailsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.TenantDetailsSortColumn;

    ascending: boolean;

}
